import React from 'react';
import { DatePickerBox } from '../../components/common';
import { BUTTON } from '../../constants';
import { capitalize } from '../misc';
export function poDataCompiler(data = []) {
  let finalData = [];
  data.map((obj) => {
    let poData = {
      id: obj.id,
      url: obj.name.replaceAll('/', '_'),
      name: obj.partner_ref || obj.name || 'N/A',
      contact: obj.partner_id.name,
      schedule_date: obj.effective_date || 'N/A',
      qty: obj.order_line.reduce((acc, cum) => {
        acc += cum.product_qty;
        return acc;
      }, 0),
      received_qty: obj.order_line.reduce((acc, cum) => {
        acc += cum.qty_received;
        return acc;
      }, 0),
      bill_amount:
        obj.invoice_status === 'to invoice'
          ? parseFloat(
              obj.order_line.reduce((acc, cum) => {
                let qty = parseFloat((cum.qty_to_invoice * cum.price_unit).toFixed(2)) || 0;
                let tax = cum.taxes_id.length ? parseFloat(((+cum.taxes_id[0]?.name.slice(0, 2) / 100) * qty).toFixed(2)) : 0;
                return acc + qty + tax;
              }, 0).toFixed(2)
            )
          : 0,
      currency_code: obj.currency_id.name,
      receipt_status: capitalize(obj?.receipt_status) || 'N/A',
      amount: obj.amount_total,
      origin: capitalize(obj?.partner_ref) || obj?.name || 'N/A',
      invoice_status: capitalize(obj?.invoice_status) || 'N/A',
      lot: obj?.lot_name || 'N/A',
      container_no: obj?.container_no || 'N/A',
      invoice_no: obj?.invoice_number || 'N/A',
      data: obj,
    };
    finalData.push(poData);
  });
  return finalData;
}
export function poDetailsCompiler(data = []) {
  let finalData = [];
  let val = 0;
  data.map((obj) => {
    let poDetailsData = {
      product: obj?.product_id?.display_name,
      variant_size: obj?.product_id?.variant_size || 'N/A',
      variant_color: obj?.product_id?.variant_color || 'N/A',
      qty: obj?.product_qty,
      rolls: obj?.no_of_rolls,
      received: obj?.qty_received,
      lot_no: obj?.future_lot || 'N/A',
      balance:
        obj?.product_qty - obj?.qty_received >= 0
          ? (obj?.product_qty - obj?.qty_received)?.toFixed(2)
          : val.toFixed(2),
      billed: obj?.qty_invoiced,
      uom: obj?.product_uom?.name,
      purchase_method: obj?.product_id?.purchase_method,
      produced_qty: obj?.produced_qty,
      unit_price: obj?.price_unit,
      tax: obj.taxes_id?.[0]?.name || 'N/A',
    };
    finalData.push(poDetailsData);
  });
  return finalData;
}

export function poDetailsBox(po, dispatchData, isLoading, isBillCreationLoading) {
  let detailBoxData = [
    { name: 'Vendor', col: 1, data: po?.partner_id?.name },
    { name: 'Deliver To', col: 1, data: po?.picking_type_id?.name },
    { name: 'Purchase Agreement', col: 1, data: capitalize(po?.state) },
    { name: 'Source ', col: 1, data: capitalize(po?.partner_ref) || po?.name || 'N/A' },
    {
      name: 'Priority',
      col: 1,
      data: capitalize(po?.order_line?.[0]?.manufacture_priority) || 'N/A',
    },
    { name: 'Confirmation Date/Time', col: 2, data: po?.create_date },
    { name: 'Receipt Date/Time', col: 2, data: po?.date_approve },
    { name: 'Effective Date/Time', col: 2, data: po?.effective_date || 'N/A' },
    { name: 'Invoice No', col: 2, data: po?.invoice_number || 'N/A' },
    {
      name: 'Bill Date',
      col: po?.createBill ? 2 : '',
      isCustom: po?.createBill,
      view: function ({ value, setValue, clickHandler, showSave }) {
        return (
          <div key={po?.name} className="row mb-3">
            <div className="col-6 title">{'Bill Date'}</div>
            <div className="col-6 d-flex flex-test flex-wrap align-items-center gap-3">
              <DatePickerBox
                value={value}
                setValue={setValue}
                clickHandler={clickHandler}
                showSave={showSave}
                btnName={BUTTON.SAVE}
                isBillCreationLoading={isBillCreationLoading}
              />
            </div>
          </div>
        );
      },
    },
  ];
  return detailBoxData;
}
